<template>
  <div>
    <PageAllow controller="TemplatePriceAdjustTasks" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('TemplatePriceAdjustTasks.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              class="ms-1"
              width="110px"
              href="/#/template-price-adjust-tasks-new"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("TemplatePriceAdjustTasks.createBtn") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="task_code"
                  v-model="options.task_code"
                  @text="task_code = $event"
                  :label="$t('TemplatePriceAdjustTasks.Fields.task_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('TemplatePriceAdjustTasks.status.title')"
                  :items="$consts.templatePriceAdjustTasks.status"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="mx-4 my-4">
        <v-data-table
          id="template_price_adjust_tasks_table"
          :headers="headers"
          class="elevation-2 pa-4 mt-4"
          :items="templatePriceAdjustTasks"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :footer-props="$t('$config.footer-props')"
          :loading="loading"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | templatePriceAdjustTasksStatusColor"
              :text-color="item.status | templatePriceAdjustTasksStatusTextColor"
              >{{ item.status | templatePriceAdjustTasksStatusText }}
            </v-chip>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.schedule_time="{ item }">
            {{ item.schedule_time | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  :href="'/#/template-price-adjust-tasks/' + item.id"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("TemplatePriceAdjustTasks.actions.detail") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.viewInfo", [$t("TemplatePriceAdjustTasks.ObjectName")])
              }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.actions.edit">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  :href="'/#/template-price-adjust-tasks/' + item.id + '/edit'"
                >
                  {{ $t("TemplatePriceAdjustTasks.actions.edit") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.editInfo", [$t("TemplatePriceAdjustTasks.ObjectName")])
              }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.actions.cancel">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="cancelTarget = item; cancelAlert = true"
                >
                  <v-icon x-small class="pe-1">fa-exclamation</v-icon>
                  {{ $t("TemplatePriceAdjustTasks.actions.cancel") }}
                </v-btn>
              </template>
              <span>{{
                $t("CRUD.cancelInfo", [$t("TemplatePriceAdjustTasks.ObjectName")])
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('TemplatePriceAdjustTasks.ObjectName')"
      :code="cancelTarget ? cancelTarget.task_code : ''"
      @confirm="cancelAlert = false; doCancel()"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogDelete from "@/components/plugins/DialogDelete";
import TemplatePriceAdjustTasks from "@/api/template_price_adjust_tasks";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  task_code: "",
  status: [1, 2, 3],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogDelete,
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.templatePriceAdjustTasks"),
          disabled: true,
          href: "/template-price-adjust-tasks",
        },
      ];
      return items;
    },

    headers() {
      let headers = [
        {
          text: i18n.t("TemplatePriceAdjustTasks.Fields.task_code"),
          align: "start",
          sortable: false,
          value: "task_code",
        },
        {
          text: i18n.t("TemplatePriceAdjustTasks.Fields.memo"),
          align: "start",
          sortable: false,
          value: "memo",
        },
        {
          text: i18n.t("TemplatePriceAdjustTasks.Fields.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("TemplatePriceAdjustTasks.Fields.schedule_time"),
          align: "start",
          sortable: false,
          value: "schedule_time",
        },
        {
          text: i18n.t("TemplatePriceAdjustTasks.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    templatePriceAdjustTasks: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("template-price-adjust-tasks-options")
        ? sessionStorage.getItem("template-price-adjust-tasks-options")
        : JSON.stringify(defaultOptions)
    ),
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    task_code: "",
    loading: false,
    cancelAlert: false,
    cancelTarget: null,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("template-price-adjust-tasks", [])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.task_code = "";
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      if (this.$refs.task_code) this.$refs.task_code.clear();
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        task_code: this.task_code,
      });
    },
    getTemplatePriceAdjustTasksFromAPI() {
      this.loading = true;
      TemplatePriceAdjustTasks.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templatePriceAdjustTasks = response.data.template_price_adjust_tasks;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    doCancel() {
      this.$store.dispatch("fullscreenLoading");
      TemplatePriceAdjustTasks.cancel(this.cancelTarget.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              this.$t("TemplatePriceAdjustTasks.Messages.cancelSuccess")
            );
            this.getTemplatePriceAdjustTasksFromAPI();
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getTemplatePriceAdjustTasksFromAPI();
        sessionStorage.setItem(
          "template-price-adjust-tasks-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>
